// WHY: a scheduled search row carries no schedule time of its own, so lastUpdatedAt stands in for it.
import { DraftStatusType } from '~/models';
import { DraftCreationSource } from '~/types/api.model';
const mapStatus = (status, fallbackScheduleTime)=>{
    if (status === 'scheduled') {
        return {
            type: DraftStatusType.Scheduled,
            schedule: {
                time: fallbackScheduleTime
            }
        };
    }
    if (status === 'archived') {
        return {
            type: DraftStatusType.Archived
        };
    }
    return {
        type: DraftStatusType.Active
    };
};
export const mapSearchRowToDraftSummary = (row)=>{
    var _row_contactId;
    return {
        id: row.id,
        isSample: false,
        lastModifiedBy: {
            email: row.serviceProvider.assignee.email,
            firstName: row.serviceProvider.assignee.firstName,
            id: row.serviceProvider.assignee.userid,
            lastName: row.serviceProvider.assignee.lastName,
            phone: ''
        },
        lastModifiedOn: Date.parse(row.lastUpdatedAt),
        title: row.agreementName,
        clientContactId: (_row_contactId = row.contactId) !== null && _row_contactId !== void 0 ? _row_contactId : null,
        status: mapStatus(row.status, row.lastUpdatedAt),
        creationSource: DraftCreationSource.Unknown
    };
};
